import './polyfills';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import App from './containers/app';
import configureStore from './store';
import './styles/index.scss';
import Bugsnag from '@bugsnag/js';
import { ErrorBoundary } from './config/bugsnag';
import { FeaturesProvider } from './hooks/use-features';
import ErrorView from './components/common/error-view';
import theme from './styles/theme';

const store = configureStore();

// Enrich every error captured by the boundary with page context before it is
// sent to Bugsnag. Runs even when the fallback UI cannot be rendered.
const onErrorBoundary = event => {
  if (typeof window !== 'undefined') {
    event.addMetadata('page', {
      url: window.location.href,
      path: window.location.pathname,
      referrer: document.referrer || null,
      userAgent: navigator.userAgent,
    });
  }

  Bugsnag.leaveBreadcrumb('React ErrorBoundary caught an error', {
    message: event.errors?.[0]?.errorMessage,
    path: typeof window !== 'undefined' ? window.location.pathname : undefined,
  });
};

ReactDOM.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ErrorBoundary FallbackComponent={ErrorView} onError={onErrorBoundary}>
          <FeaturesProvider>
            <App />
          </FeaturesProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>,
  document.getElementById('root')
);
